export default {
  'Please select an output format': 'Silahkan pilih format output',
}